import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningLead } from './components/OpeningLead';
import { ChinaGallery } from './components/ChinaGallery';
import { ProblemSection } from './components/ProblemSection';
import { OldSolutionsFail } from './components/OldSolutionsFail';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhomSection } from './components/ForWhomSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { CloseSection } from './components/CloseSection';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-charcoal font-sans selection:bg-china-red/20 selection:text-china-red" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningLead data-id="element-2" />
      <ChinaGallery data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <OldSolutionsFail data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <ForWhomSection data-id="element-8" />
      <ObjectionsSection data-id="element-9" />
      <CloseSection data-id="element-10" />
      <Footer data-id="element-11" />
      <FloatingCTA data-id="element-12" />
    </div>;
}